<template>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-9 align-self-center">
        <h2>{{ $t("navigations.export output") }}</h2>
      </div>
      <!-- <div class="col-2 align-self-end" v-if="showFilterBtn==true && $store.getters.getVersion">
        <label v-if="versionList!=null" class="mb-0" for="interimSelectedVersion">{{ $t("navigations.interim version")}}</label>
        <input disabled type="text" v-model="interimSelectedVersion" class="form-control" name="" id="interimSelectedVersion">
      </div> -->
      <div class="col-3 d-flex align-items-center justify-content-end align-self-center gap-2">
        <label v-if="versionList!=null" class="mb-0 text-nowrap" for="interimVersion">{{ $t("navigations.interim version")}}</label>
        <select class="form-select form-select-sm py-0" @change="setVersionNo()" name="interimVersion" id="interimVersion" v-model="interimVersion">
          <option value="">
            {{ $t("navigations.none") }}
          </option>
          <option v-for="version in versionList" :key="version" :value="version">
            {{ version }}
          </option>
        </select>
      </div>
    </div>
    <div class="wrapper wrapper-content">
    <div class="ibox-content">  
      <!-- Tree View -->
       <div class="text-center" v-if="initialTreeLoader">
        <div>{{ $t("navigations.please wait while the tree is being generated") }}</div>
        <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
       </div>
  
      <div v-else class="tree-container">
        <div class="pl-2" v-if="treeData.length!=0">
          <ul class="modal-tree pl-0" > 
          <li v-for="(node, index) in Object.keys(treeData)" :key="`treeData-${index}`">
            {{ treeData._id }}
            <input class="mr-2" type="checkbox" :id="`treeData-${index}`" v-model="rootChecked[`treeData-${index}`]"
              @change="toggleChildren(treeData[node], index,`treeData-${index}`)" />
            <label class="modal_tree_label" :for="`treeData-${index}`">{{ treeData[node].Headingindex }} {{ treeData[node].Headingname }}</label>
            <ul v-if="treeData[node].Reports.length != 0">
              <li v-for="childlabels, vindex in treeData[node].Reports" :key="`treeData-${index}-${vindex}`">
                <input class="mr-2" type="checkbox" @change="toggleChild(treeData[node].Reports,index, vindex, $event.target.checked)" :id="`treeData-${index}-${vindex}`"
                  v-model="childrenChecked[`treeData-${index}-${vindex}`]" />
                <label class="modal_tree_label" :for="`treeData-${index}-${vindex}`">{{ childlabels.Subindex }} {{
                  childlabels.Reportname }} </label>
                 <ul class="pl-3">            
                  <li v-for="(value,subindex) in childlabels.Programms" :key="value.ReportId" >
                    <input class="mr-2" type="checkbox" :id="`treeData-${index}-${vindex}-${subindex}`"
                    v-model="subchildrenChecked[`treeData-${index}-${vindex}-${subindex}`]" @change="toggleSubChild(index, vindex, subindex,$event.target.checked,value)"/>        
                    
                    <label :for="`treeData-${index}-${vindex}-${subindex}`"
                    class="modal_tree_label px-1"><span
                         v-if="value.Status!='No Program'">
                         <span :class="getBadgeClass(value.Status,value.HasOutput,'output')" ></span>
                        <span :class="getBadgeClass(value.Status,value.HasOutput,'status')" class="mr-1"></span>
                      </span><span v-if="value.Status && value.ReportType!=null">{{ value.ReportType[0] }}  </span> {{ childlabels.Subindex }}<span>.</span>{{value.Version}} {{ value.ProgramName }} - {{value.Version}}
                   
                      <!-- Status and Developer Information -->
                    <template v-if="value.Status!=null">
                      <span class="ml-2" v-if="value.DeveloperName!='string' && value.DeveloperName!='' && value.DeveloperName!=null"> <strong>{{ $t("navigations.primary programmer") }}</strong> - {{ value.DeveloperName }}</span>
                    <span class="px-1" v-if="value.QCName!='string' && value.QCName!='' && value.QCName!=null">|</span> <span v-if="value.QCName!='string' && value.QCName!='' && value.QCName!=null"> <strong>{{ $t("navigations.qc programmer") }}</strong> - {{ value.QCName }}</span>
                    </template>
                
                      </label>
                     
                  </li>
              
              </ul>
              </li>
            </ul>
          </li>
          </ul>
          <div class="text-center">
            <button type="button" @click.prevent="saveProgramIds()" class="save_btn position-relative d-flex align-items-center py-2 px-3 mr-2" 
              :class="{ 'disabled-btn-cls': showProgramLoading == true }">
              <div class="toc-loader position-absolute"
              :class="{ 'opacity-0': showProgramLoading == false, 'opacity-1': showProgramLoading == true }">
              <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
              </div>
              <div :class="{ 'opacity-1': showProgramLoading == false, 'opacity-0': showProgramLoading == true }">{{
              $t("navigations.export") }}</div>
            </button>
          </div>
        </div>
        <div v-else >
        <h4 class="text-center">{{ $t('navigations.no tree data found') }}</h4>
      </div>
      </div>
     
     
    </div>
  </div>
  </template>
  <script src="./exportOutput.js"></script>
  <style scoped>
  @import "./tree.css";
  @import "../../assets/css/style.css";
  .highlight {
    background-color: #ffeb3b;
  }
  .comparison-table{
    table-layout: fixed;
    width:100%
  }
  .comparison-table tbody tr td:first-child,
  .comparison-table thead tr th:first-child {
    background-color: hsl(0, 0%, 100%);
    position: sticky;
    left: -1px;
  
  }
  .comparison-table tbody tr td:nth-child(2),
  .comparison-table tbody tr td:nth-child(3) {
    width:40%;
    white-space: break-spaces
  }
  .modal-tree input:checked~ul {
    display: block;
  }
  
  :checked ~ label.tree_label:before { content: url("../../assets/images/folder-close.png"); }
  
  .modal-tree .tree_label:after {
    display: none;
  }
  
  label.modal_tree_label:before {
    color: #fff;
    position: relative;
    z-index: 1;
    float: left;
    margin: 0 1em 0 -2em;
    width: 1em;
    height: 1em;
    border-radius: 1em;
    text-align: center;
    line-height: .8em;
    }
  .linkstyle {
    cursor: pointer;
  }
  
  .settings-block{
    font-size: 1rem;
    color:hsl(0, 0%, 50%);
    border:none;
    transition: transform 0.5s ease-in-out, background-color 0.5s ease-in-out ;
  }
  .settings-block .settings-icon{
    transform-origin: center center; 
  }
  .settings-block:hover .settings-icon{
    animation: rotate90 0.8s linear;
  }
  @keyframes rotate90 {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(90deg);
    }
  }
  
  
  /* .position-relative:hover .settings-icon
  {
    transform:rotate(360deg);
  } */
  .skip-all-bg{
    text-align: center;
    border-color: hsl(187, 100%, 38%);
    color: white !important;
    padding: 0.3rem 0.4rem;
    border-radius: 0.25rem;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
    background-color: hsl(187, 100%, 38%)
  }
  
  .position-relative .settings-tooltip{
    visibility: hidden;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    background-color: #616161;
    color: #fff;
    text-align: center;
    border-radius: 0.3em;
    padding: 0.1rem 0.8rem;
    right: 35px;
    top: -10px;
    font-size: 0.8rem;
    position: absolute;
    z-index: 1;
    transition: visibility 75ms ease-in;
  }
  
  .position-relative:hover .settings-tooltip,
  .position-relative:focus-within .settings-tooltip,
  .position-relative:focus-visible .settings-tooltip{
  
    visibility: visible;
    transition: visibility 30ms ease-in;
  }
  .position-relative.tooltip-hidden .settings-tooltip {
    display:none !important;
  }
  
  .position-relative .set-program-tooltip{
    visibility: hidden;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    background-color: #616161;
    color: #fff;
    text-align: center;
    border-radius: 0.3em;
    padding: 0.1rem 0.8rem;
    right: 35px;
    top: -10px;
    font-size: 0.8rem;
    position: absolute;
    z-index: 1;
    transition: visibility 75ms ease-in;
  }
  
  .position-relative:hover .set-program-tooltip,
  .position-relative:focus-within .set-program-tooltip,
  .position-relative:focus-visible .set-program-tooltip{
  
    visibility: visible;
    transition: visibility 30ms ease-in;
  }
  .position-relative.tooltip-hidden .set-program-tooltip {
    display:none !important;
  }
  .position-relative .compare-program-tooltip{
    visibility: hidden;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    background-color: #616161;
    color: #fff;
    text-align: center;
    border-radius: 0.3em;
    padding: 0.1rem 0.8rem;
    right: 35px;
    top: -10px;
    font-size: 0.8rem;
    position: absolute;
    z-index: 1;
    transition: visibility 75ms ease-in;
  }
  
  .position-relative:hover .compare-program-tooltip,
  .position-relative:focus-within .compare-program-tooltip,
  .position-relative:focus-visible .compare-program-tooltip{
  
    visibility: visible;
    transition: visibility 30ms ease-in;
  }
  .position-relative.tooltip-hidden .compare-program-tooltip {
    display:none !important;
  }
  .linkstyle {
    cursor: pointer;
  }
  .add-block-title {
    color: #ffffff;
    background-color: #768DD3;
  }
  .option_modal__containers {
    width: min(600px, 90%);
    background: #fff;
    border-radius: 4px;
    overflow: auto;
    min-height: 150px;
    position: fixed;
    margin-top: 100px;
    max-height: 400px;
  }
  .add_page_modal_wrapper,
  .modal__wrapper__component {
    position: absolute;
    inset: 0;
    background: rgb(0 0 0 / 18%);
    height: 100pc;
    width: 100%;
    display: flex;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
    z-index: 3000;
  }
  .sub-level-menu:hover,
  .level-menu:hover
  {
    background-color: rgba(0,0,0, 0.06);;
  }
  
  .toc-side-popup {
    position: absolute;
    text-align: left;
    top: 6px;
    border-radius: 5px;
    border: 1px solid #e7eaec;
    background-color: #fff;
    width: 140px;
    box-shadow: 3px 3px 3px hsla(0,0%,62.7%,.5);
    z-index: 200;
  }
  
  .toc-side-popup>div {
    cursor: pointer;
    padding: 0.5rem;
  }
  
  .toc-side-popup>div:hover {
    background-color: #e4eaf9;
  }
  
  .float-right .tool-tip {
    visibility: hidden;
    width: max-content;
    background-color: #616161;
    color: #fff;
    text-align: center;
    border-radius: 0.3em;
    padding: 0.1rem 0.8rem;
    right: 15px;
    top: -15px;
    font-size: 0.8rem;
  
    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    -webkit-transition: visibility 75ms ease-in;
    transition: visibility 75ms ease-in;
  }
  
  .plan-side-popup>div {
    cursor: pointer;
    padding: 0.5rem;
  }
  
  .plan-side-popup>div:hover {
    background-color: #e4eaf9;
  }
  
  .horizondalscroll {
    overflow-y: auto;
    max-height: 500px;
  }
  
  .modal__title {
    background-color: #618bd7;
    color: #fff;
  }
  .toc-side-popup-sub {
    position: absolute;
    text-align: left;
    right: 45px;
    top: 13px;
    border-radius: 5px;
    border: 1px solid #e7eaec;
    background-color: rgba(255, 255, 255, 1);
    width: fit-content;
    box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
    z-index: 200;
  }
  
  .toc-side-popup-sub > div {
    cursor: pointer;
    padding: 0.6rem 0.8rem;
  }
  
  .toc-side-popup-sub > div:hover {
    background-color: #e4eaf9;
  }
  
  .badge-grn {
    background-color: #1ab394;
  }
  
  .opacity-05 {
    opacity: 0.5;
  }
  
  .opacity-0 {
    opacity: 0;
  }
  
  .opacity-1 {
    opacity: 1;
  }
  
  .left-220{
    left:220px;
  }
  
  .right-50{
    right:50px
  }
  .delete-icon{
    width:1em;
  }
  .badge-black{
   background-color: rgb(10, 10, 10);
  }
  .toc-badge{
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 600;
    font-size:0.7rem;
    color:#fff;
    border-radius: 0.25rem;
    text-shadow: none;
    white-space: nowrap;
  }
  .rounded-radius{
    border-radius: 30px;
  }
  .blank-wrapper{
    position: fixed;
    inset: 0;
    background: rgb(0 0 0 / 30%);
    color:rgb(255, 255, 255);
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
    z-index: 3000;
    /* pointer-events: none; */
  }
  .height-450{
    height:450px;
    overflow-y: scroll;
  }
  .highlighted-background{
    background-color: hsl(0, 0%, 93%);
  }
  .iframe-block {
    width: 100%;
    height: 500px
  }
  .iframe-block-visible{
    overflow: visible;
    /* height:100vh;
    overflow:visible;
    max-height: 100%; */
  }
  .multiselect-theme {
    --ms-option-bg-selected-pointed: rgb(210, 210, 210);
    --ms-option-bg-selected: rgb(210, 210, 210);
    --ms-option-color-selected: #000;
    --ms-option-color-selected-pointed: #000;
    --ms-tag-color: #000;
    --ms-tag-font-size: 0.7rem;
    --ms-tag-bg: rgb(210, 210, 210);
    
  }
  
  .disabled-btn-cls {
    opacity: 0.6;
    pointer-events: none;
  }
  
  .custom-badge{
    display: inline-block;
    width: 13px;
    height: 13px;
   
    line-height: 28px;
    position: relative;
    top: 1px;
  }
  .status-b-radius{
    border-radius: 3px;
  }
  
  /* Popver style starts; */
  .ellipsis-btn{
    anchor-name:--manage-btn;
    border:0;
  }
  
  .ellipsis-btn:hover{
    background-color: rgba(234, 234, 234, 1)
  }
  .popup-menu, .popup-submenu {
    position:absolute;
    inset: auto;
    text-align: left;
    border-radius: 5px;
    border: 1px solid #e7eaec;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
    z-index: 200;
  }
  .popup-menu{
    position-try-fallbacks: --bottom;
    top:anchor(bottom);
    right:anchor(right);
    width:160px;
  }
  .popup-submenu{
    top:anchor(bottom);
    right:anchor(left);
    width:fit-content;
    margin-inline-end: 5px;
  }
  
  .popup-menu> div, .popup-submenu > div {
    cursor: pointer;
    padding: 0.6rem 0.8rem;
  }
  .popup-menu> button{
   border:0;
   font-size:0.8rem;
   font-weight:400;
   color:rgba(0,0,0);
   padding: 0.6rem 0.8rem;
  }
  .popup-menu> .popup-menu-block:hover, .popup-submenu> div:hover,.popup-menu> button:hover {
    background-color: #e4eaf9;
  }
  [popover]:popover-open {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    animation: fadeIn 0.2s ease-in-out;
  }
  
  .nested-popover-btn {
    display: block;
    margin-top: 5px;
    background: #f1f1f1;
    border: none;
    padding: 5px;
    cursor: pointer;
    width: 100%;
    text-align: left;
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
  }
  
  @position-try --bottom{
    inset:auto;
    bottom:anchor(top);
    right:anchor(left)
  }
  /* Popver style ends */
  /* Tab CSS starts*/
  .modal-nav.modal-nav-tabs li
  {
    background: none;
    border: none;
  }
  .modal-nav-tabs>li>a
  {
    display: inline-block;
    color: #6d6d6d;
    font-weight: 700;
  
  }
  .modal-nav-tabs .modal-nav-link {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    padding: 5px 20px;
  }
  .modal-nav-tabs .modal-nav-link:hover, .modal-nav-tabs .modal-nav-link:focus {
    border-color: #e9ecef #e9ecef #dee2e6;
    isolation: isolate;
  }
  .modal-nav-tabs .modal-nav-link.disabled {
    color: #6c757d;
    background-color: transparent;
    border-color: transparent;
  }
  .modal-nav-tabs .modal-nav-link.active,
  .modal-nav-tabs .nav-item.show .modal-nav-link {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff;
  }
  .ibox-tab-content{
    color: inherit;
    padding: 10px;
    border-color: #eeeeee;
    -o-border-image: none;
    border-image: none;
    border-top-style: solid;
    border-top-width: 1px;
  }
  /* Tab CSS ends */
  </style>